import { createUrl } from './create-url';

const Sites = {
    audi: 'https://www.audibilforsakring.se/skada',
    cupra: 'https://anmal-skada.app.cuprabilforsakring.se/',
    dacia: 'https://www.daciaforsakring.se/skada',
    ford: 'https://www.fordforsakring.se/skada',
    izuzu: 'https://www.isuzuforsakring.se/skada',
    kia: 'https://www.kiabilforsakring.com/skada',
    mercedes: 'https://www.mercedes-benzforsakring.se/skada',
    mg: 'https://www.mgbilforsakring.se/skada',
    nissan: 'https://www.nissanforsakring.se/skada',
    polestar: 'https://www.polestarinsurance.se/vid-skada',
    porsche: 'https://www.porschebilforsakring.se/skada',
    renault: 'https://www.renaultforsakring.se/skada',
    rulla: 'https://www.if.se/privat/samarbeten/rulla-vidare/vid-skada',
    saab: 'https://www.saabforsakring.se/skada',
    seat: 'https://www.seatbilforsakring.se/skada',
    skoda: 'https://www.skodabilforsakring.se/skada',
    subaru: 'https://www.subaruforsakring.se/skada',
    volkswagentransport: 'https://www.volkswagentransportbilarforsakring.se/skada',
    volkswagen: 'https://www.volkswagenbilforsakring.se/skada',
    volvia: 'https://www.volvia.se/vid-skada',
};

const IfSites = {
    bmw: 'https://www.if.se/privat/forsakringar/fordonsforsakringar/bilforsakring-for-din-bmw/skada',
    mini: 'https://anmal-skada.if.se/motorskada',
    opel: 'https://anmal-skada.if.se/motorskada',
};

export const getMobilityClaimsPage = (url: string): string => {
    const page = createUrl(url);
    if (!page) return '';

    const hostname = page.hostname;
    const href = page.href;

    for (const key of Object.keys(Sites)) {
        if (hostname.includes(key)) {
            return Sites[key];
        }
    }

    for (const key of Object.keys(IfSites)) {
        if (href.includes(key)) {
            return IfSites[key];
        }
    }

    return '';
};
